import type { Weekdays } from '../../interfaces/common/weekdays';

export const WEEKDAYS = [
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
] as const satisfies (keyof Weekdays)[];
